// components/FillDays/FillDays.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import CustomDatePicker from '../Common/DatePicker';
import styled from 'styled-components';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';

const FillDays = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);


  const handleFill = async () => {
  try {
    let url = '/sign/fill';
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate.toLocaleDateString('en-CA'));
    if (endDate) params.append('end_date', endDate.toLocaleDateString('en-CA'));
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const response = await api.get(url);
	alert(response.data.message)
  } catch (error) {
      console.error('Filling days failed', error);
      alert('Filling days failed');
	  }
  };
  
  return (
    <div>
      <h2>Rellenar días</h2>
	  <FormContainer>
      <FullWidth>
          <CustomDatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholder="Selecciona fecha de inicio" isRequired={true} />
       </FullWidth>
	   <FullWidth>
          <CustomDatePicker selected={endDate} onChange={(date) => setEndDate(date)} placeholder="Selecciona fecha de fin" />
       </FullWidth>
	  <FullWidth>
      <Button onClick={handleFill}>Rellenar</Button>
	  </FullWidth>
	  </FormContainer>
    </div>
  );
};

export default FillDays;